const getters = {
    refereeStatus: state => state.refereeStatus,
    refereeErrors: state => state.refereeErrors,
    seasons: state => state.seasons,
    venues: state => state.venues,
    roster: state => state.roster,
    availability: state => state.availability,
}

export default getters
